export const SET_SCHEDULE = 'setScheduleDay'
export const SET_TODAY_SCHEDULING = 'setTodayScheduling'
export const SET_TODAY_SCHEDULING_PAUSES = 'setTodaySchedulingPauses'
export const SCHEDULE_RESET_STATE = 'scheduleResetState'
export const SET_PAYMENT_TYPES = 'setPaymentTypes'
export const SCHEDULE_REMOVE_SERVICE = 'scheduleRemoveService'
export const SCHEDULE_ADD_SERVICE = 'scheduleAddService'
export const SET_SCHEDULE_BMS_SERVICES = 'setScheduleBmsServices'
export const SCHEDULE_CREATE_RESET_STATE = 'scheduleCreateResetState'